import {Component} from '@angular/core';


@Component({
    selector: 'app-business',
    templateUrl: './business.component.html',
    styleUrl: './business.component.css'
})
export class BusinessComponent {

}